module.exports = __webpack_public_path__ + "static/img/Joel-King.82b7548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joel-King.jpg
// module id = V4ry
// module chunks = 0